// Menu.
$(".toggle").on("click", () => {
  $(".toggle").toggleClass("toggle--open");
  $(".navigation").slideToggle();
});
